import ImageDisplay from '../../components/ImageDisplay';

export default function MatchModal({ profile, onClose }) {
  if (!profile) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="w-[60vw] min-w-[200px] overflow-hidden rounded-2xl bg-card text-center shadow-lg">
        {profile.images?.[0] && (
          <ImageDisplay 
            imageData={profile.images[0]} 
            imageStrategy="cover"
            className="h-64 w-full" 
          />
        )}
        <div className="p-6">
          <h2 className="text-xl font-bold text-foreground">{profile.name}</h2>
          <div className="mt-4 flex flex-col gap-2">
            <button
              onClick={onClose}
              className="w-full rounded-full bg-muted py-3 text-sm font-semibold text-muted-foreground"
            >
              Keep Swiping
            </button>
            <button
              onClick={() => {
                onClose();
                // TODO: Navigate to chat with this user
              }}
              className="flex w-full items-center justify-center gap-2 rounded-full bg-primary py-3 text-sm font-semibold text-primary-foreground"
            >
              Send Message
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" transform="scale(-1, 1)" transform-origin="center">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
